// extracted by mini-css-extract-plugin
module.exports = {"text":"CopyAffiliateLinkButton_text__qGsli"};